import { Component } from '@angular/core';
import {LoginService} from '../login/login.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {ConfiguracoesService} from "../configuracoes/configuracoes.service";

declare let $: any;

@Component({
  selector: 'aside-nav',
  templateUrl: 'aside.component.html'
})
export class AsideComponent {

  userInfo: any = {};
  permissoesMenu = [];
  isAdm = false;
  logoPainelUrl: string = null;

  constructor(
    protected login: LoginService,
    private func: Funcoes,
    public global: Global,
    private configService: ConfiguracoesService
  ){
    login.getUserInfo()
      .subscribe(data => {
        this.userInfo = data;
        this.criaPermissoesMenu();
      },
      error => {
        this.login.trataErro(error.json());
      });

    this.isAdm = (this.func.getTokenInfo()['adm'] == 1);
    this.carregarLogo();
  }

  carregarLogo() {
    this.configService.getConfiguracoes().subscribe(
      (json: any) => {
        if (json && json.Payload && json.Payload.length > 0) {
          let item = Array.isArray(json.Payload[0]) ? json.Payload[0][0] : json.Payload[0];
          if (item && item.logo_painel) {
            let path = item.logo_painel;
            this.logoPainelUrl = path.startsWith('http') ? path : this.global.dominio_site + path;
          }
        }
      },
      error => {}
    );
  }

  sair(){
    this.login.sair();
  }

  // cria um array com os id permitidos para o menu
  criaPermissoesMenu(){

    let permissoes = [];

    for(let i in this.userInfo.privilegios){
      if(this.userInfo.privilegios[i].consultar || this.userInfo.privilegios[i].editar){
        permissoes.push(this.userInfo.privilegios[i].id_acao);
      }
    }

    this.permissoesMenu = permissoes;

    $.getScript("/assets/js/core.js");

  }

  podeEditar(idAcao: string | number): boolean {
    if (!this.userInfo || !this.userInfo.privilegios) {
      return false;
    }
    const privilegio = this.userInfo.privilegios.find(p => p.id_acao == idAcao);
    return privilegio ? !!privilegio.editar : false;
  }

  podeConsultar(idAcao: string | number): boolean {
    if (!this.userInfo || !this.userInfo.privilegios) {
      return false;
    }
    const privilegio = this.userInfo.privilegios.find(p => p.id_acao == idAcao);
    return privilegio ? !!privilegio.consultar : false;
  }

  userIsMaster(): boolean {
    return this.func.userIsMaster();
  }

  temTipoCliente(idTipo: string | number): boolean {
    if (!this.userInfo) {
      return false;
    }
    if (this.userInfo.cliente && this.userInfo.cliente.tipos && Array.isArray(this.userInfo.cliente.tipos)) {
      return this.userInfo.cliente.tipos.some(t => String(t.id_tipo) === String(idTipo));
    }
    if (this.userInfo.tipos && Array.isArray(this.userInfo.tipos)) {
      return this.userInfo.tipos.some(t => String(t.id_tipo) === String(idTipo));
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/painel/aside.component.ts